import script from "./NoticiaDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaDetailView.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaDetailView.vue?vue&type=style&index=0&id=47e471d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e471d6"]])

export default __exports__